module.exports = __webpack_public_path__ + "img/logo-app.5d2522b6.svg";